module.exports = __webpack_public_path__ + "img/bg.ea5ba84a.jpg";